import Router from 'vue-router'
import store from '@/store'

import tokenStorage from '@/utils/storage/token'
import * as pages from '@/pages'

import features from '@/entities/features'
import * as layouts from '@/layouts'

const routes = [{
  path: '/login',
  name: 'LoginLayout',
  component: layouts.login,
  children: [{
    path: '/login',
    name: 'login',
    component: pages.login,
    meta: {title: 'Sign In'},
  }]
},
  {
    path: '/',
    component: layouts.default,
    children: [
      {
        path: '/',
        name: 'dashboard',
        component: pages.dashboard,
        meta: {title: 'Personal desk', feature: features.DASHBOARD},
      },
      {
        path: '/workline',
        name: 'workline',
        component: pages.workline,
        meta: {title: 'Workline', feature: features.CALENDAR},
      },
      // Spaces
      {
        path: '/spaces',
        name: 'spaces-list',
        component: pages.spaces.list,
        meta: {title: 'Spaces', feature: features.SPACES},
      },
      {
        path: '/spaces/:space_id/edit',
        name: 'spaces-edit',
        component: pages.spaces.form,
        meta: {title: 'Spaces', feature: features.SPACES},
      },
      // Articles
      {
        path: '/spaces/:space_id/articles/:article_id?',
        name: 'articles-tree',
        component: pages.spaces.articles.list,
        meta: {title: 'Spaces', feature: features.SPACES},
      },
      {
        path: '/spaces/:space_id/articles/:article_id/edit',
        name: 'articles-edit',
        component: pages.spaces.articles.form,
        meta: {title: 'Spaces', feature: features.SPACES},
      },
      // Projects
      {
        path: '/projects',
        name: 'projects-list',
        component: pages.projects.list,
        meta: {title: 'Projects', feature: features.PROJECTS},
      },
      {
        path: '/projects/:project_id/edit',
        name: 'projects-edit',
        component: pages.projects.form,
        meta: {title: 'Project Edit', feature: features.PROJECTS_EDIT},
      },
      {
        path: '/projects/:project_id/report',
        name: 'projects-report',
        component: pages.projects.report,
        meta: {title: 'Project Reports', feature: features.PROJECT_REPORTS},
      },
      // Tasks
      {
        path: '/projects/:project_id/tasks',
        name: 'tasks-list',
        component: pages.projects.tasks.list,
        meta: {title: 'Project Tasks', feature: features.PROJECTS},
      },
      {
        path: '/projects/:project_id/tasks/:task_id',
        name: 'tasks-form',
        component: pages.projects.tasks.form,
        meta: {title: 'Project Task', feature: features.PROJECTS},
      },
      {
        path: '/users',
        name: 'users-list',
        component: pages.users.list,
        meta: {title: 'Users', feature: features.USERS},
      },
      {
        path: '/users/:user_id',
        name: 'users-form',
        component: pages.users.form,
        meta: {title: 'Users', feature: features.USERS},
      },
      {
        path: '/times',
        name: 'times',
        component: pages.times.list,
        meta: {title: 'Time Confirmation', feature: features.TIMES},
      },
      // Reports
      {
        path: '/reports/summary',
        name: 'summary-report',
        component: pages.reports.summary,
        meta: {title: 'Report Summary', feature: features.REPORTS},
      },
      {
        path: '/reports/calendar',
        name: 'track-calendar',
        component: pages.reports.calendar,
        meta: {title: 'Track Calendar', feature: features.CALENDAR},
      },
      {
        path: '/reports/payable-hours',
        name: 'payable-hours',
        component: pages.reports.payableHours,
        meta: {title: 'Payable Hours', feature: features.REPORTS},
      },
      // Profile
      {
        path: '/profile',
        name: 'profile',
        component: pages.profile,
        meta: {title: 'Profile', feature: features.PROFILE},
      },
      // Instances
      {
        path: '/instances',
        name: 'instances-list',
        component: pages.instances.list,
        meta: {title: 'Instances', feature: features.INSTANCES},
      },
      {
        path: '/instances/:instance_id',
        name: 'instances-form',
        component: pages.instances.form,
        meta: {title: 'Instance', feature: features.INSTANCES},
      },
      // Features
      {
        path: '/features',
        name: 'features-list',
        component: pages.features.list,
        meta: {title: 'Features', feature: features.FEATURES},
      },
      {
        path: '/features/:feature_id',
        name: 'features-form',
        component: pages.features.form,
        meta: {title: 'Feature', feature: features.FEATURES},
      },
      // Roles
      {
        path: '/roles',
        name: 'roles-list',
        component: pages.roles.list,
        meta: {title: 'Roles', feature: features.ROLES},
      },
      {
        path: '/roles/:role_id',
        name: 'roles-form',
        component: pages.roles.form,
        meta: {title: 'Role', feature: features.ROLES},
      },
    ]
  },
  {
    path: '/error-page',
    name: 'ErrorLayout',
    component: layouts.error,
    children: [{
      path: '/error-page',
      name: 'error-page',
      component: pages.error,
      meta: {title: 'Error'},
    }]
  },

]

const router = new Router({routes, mode: 'history', base: '/'})
const whiteList = ['login', 'error-page']

router.beforeEach(async (to, from, next) => {
  document.title = to.meta.title

  if (whiteList.includes(to.name)) {
    next()
    return;
  }

  let token = tokenStorage.get()
  if (!token) {
    next({name: 'login'})
    return;
  }

  let user = store.getters.user ? store.getters.user : await store.dispatch('getUser')
  if (!user || !user.instanceUsers) {
    next({name: 'login'})
    return;
  }

  let features = user.instanceUsers.map(item => item.roles).flat().map(item => item.features).flat()
  if (!features.some(feature => feature.id == to.meta.feature)) {
    next({name: 'error-page'})
    console.error("Feature not allowed - " + to.meta.feature)
    return
  }

  const node = { title: to.meta.title, value: to.fullPath}
  const history = store.getters.history.filter(item => item.value != node.value).concat([node]).slice(-5);
  store.dispatch('saveHistory', history)

  next()
})

export default router


